export const UiUtil = {
  animateScroll(el: Element, padding?: number | null): void {
    const anchor = el.querySelector<HTMLElement>("div.question-scroll-anchor");
    if (anchor) {
      anchor.scrollIntoView();
    }
  },
  animateSlide(
    el: Element,
    offset: number,
    duration: number,
    callback?: Function
  ): void {
    console.log("slide...");
    const active = (el.getAttribute("data-slide-active") === "1");
    const nextPos = (active ? 0 : (offset));
    $(el).animate(
      {
        left: nextPos
      },
      duration,
      () => {
        el.setAttribute("data-slide-active", (active ? "0" : "1"));
        if (callback) { callback(); }
      }
    );
  },
  toggleAccordionIcon(
    el: Element,
    toggleClasses: string
  ): void {
    $(el)
      .parent()
      .find("[data-toggle=collapse] i")
      .toggleClass(toggleClasses);
  },
  toggleButtonState(
    button: HTMLButtonElement
  ): void {
    const loadingText = button.dataset.loadingText || "";
    if (loadingText.length === 0) {
      return;
    }
    if (!button.disabled) {
      button.dataset.originalText = button.innerHTML;
      button.disabled = true;
      button.innerHTML = loadingText;
    } else {
      const originalText = button.dataset.originalText || "";
      button.disabled = false;
      button.innerHTML = originalText;
    }
  },
  collapseDivOffTargetClick(
    collapsibleDiv: HTMLElement
  ): void {
    $(document).on("click", (ev: JQuery.ClickEvent) => {
      const collapseDiv = $(collapsibleDiv).find(".collapse.show");
      const isExpanded = collapseDiv.length;
      if (!isExpanded) {
        return;
      }
      const elementClicked = $(ev.target);
      const isInnerTarget = $(collapsibleDiv).find(elementClicked).length;
      if (!(isInnerTarget)) {
        collapseDiv.collapse("hide");
      }
    });
  },
  elementInViewport(element: HTMLElement): boolean {
    if (!element || element === undefined) {
      return false
    }
    var top = element.offsetTop;
    var left = element.offsetLeft;
    var width = element.offsetWidth;
    var height = element.offsetHeight;

    while (element.offsetParent) {
      element = element.offsetParent as HTMLElement;
      top += element.offsetTop;
      left += element.offsetLeft;
    }

    return (
      top < (window.pageYOffset + window.innerHeight) &&
      left < (window.pageXOffset + window.innerWidth) &&
      (top + height) > window.pageYOffset &&
      (left + width) > window.pageXOffset
    );
  },
  replaceDataSrcWithSrcInImageTags(currentHtmlString: string): string {
    let tempDivElement: JQuery<HTMLElement> = $("<div></div>");
    tempDivElement.html(currentHtmlString);

    tempDivElement.find("img[data-src]").each(function () {
      // tslint:disable-next-line: no-unsafe-any
      $(this).attr("src", $(this).data("src"));
      $(this).removeAttr("data-src");
    });

    tempDivElement.find("source[data-srcset]").each(function () {
      // tslint:disable-next-line: no-unsafe-any
      $(this).attr("srcset", $(this).data("srcset"));
      $(this).removeAttr("data-srcset");
    });

    return tempDivElement.html();
  },
  scrollToTop(): void {
    $("html, body").animate(
      {
        scrollTop: 0
      },
      "slow"
    );
  }
};
